var map = {
	"./1.jpg": 8352,
	"./1.png": 7508,
	"./10.png": 4302,
	"./2.jpg": 3311,
	"./2.png": 6415,
	"./3.jpg": 3314,
	"./3.png": 7398,
	"./4.jpg": 9873,
	"./4.png": 473,
	"./5.jpg": 1348,
	"./5.png": 3568,
	"./6.jpg": 3155,
	"./6.png": 3419,
	"./7.png": 2290,
	"./8.png": 9237,
	"./9.png": 9820,
	"./author.png": 6704,
	"./author2.png": 2880,
	"./author3.png": 7081,
	"./author4.png": 7110,
	"./author5.png": 911,
	"./beg.png": 9799,
	"./course-banner1.jpg": 2342,
	"./course-banner2.jpg": 9041,
	"./course-banner3.jpg": 4644,
	"./small-image/1.png": 5084,
	"./small-image/2.png": 9015,
	"./small-image/3.png": 9518,
	"./small-image/4.png": 8001,
	"./small-image/5.png": 6872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1469;